import { InternalServerErrorComponent } from './out-of-application/InternalServerError/InternalServerError.component';
import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './common/auth-guard.service';
import { HomeComponent } from './inside-of-application/home/home.component';
import { DashboardComponent } from './inside-of-application/dashboard/dashboard.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { DummyLoginComponent } from './out-of-application/dummy-login/dummy-login.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full'},
    { path: 'login', component: LoginComponent },
    { path: 'dummylogin', component: DummyLoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'unauthorize', component: UnAuthorizeComponent },
    { path: 'badrequest', component: BadRequestComponent },
    { path: 'internalservererror', component: InternalServerErrorComponent },
    { path: 'pagenotfound', component: PageNotFoundComponent },
    { path: 'sessionexpired', component: SessionExpiredComponent },
    {
        path: 'vendor',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./inside-of-application/Vendor/vendor.module').then(m => m.VendorModule)
    },
    {
        path: 'home', component: HomeComponent, canActivate: [AuthGuardService],
        children: [
            {
                path: '', component: DashboardComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService]
            },
        ]
    },
    { path: '**', redirectTo: 'pagenotfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuardService]
})
export class AppRoutingModule {
}